import { useEffect, useRef } from "react"

/**
 * Runs `fn` once per `identity`, on the first render where `isResolved` holds — a gated shell mounts
 * before its data, and survives an identity change that used to remount it.
 */
export default function useOnceResolved(isResolved: boolean, identity: string | null | undefined, fn: () => void) {
  // The identity it last ran for, not a boolean: the shell is no longer torn down between resources,
  // so a latch would block every load after the first.
  const ranFor = useRef<string | null | undefined>(undefined)

  useEffect(() => {
    if (!isResolved || ranFor.current === identity) {
      return
    }
    ranFor.current = identity
    fn()
    // Ref, not deps: `fn` is redeclared every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResolved, identity])
}
